var _excluded = ["onClick", "isSelected", "isDisabled", "isInactive", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Box } from '../../components/internal';
import { forwardRef } from '../../utils';
import { useStyleConfig } from '../../utils/use-style-config';
import { jsx as _jsx } from "react/jsx-runtime";
export var Card = forwardRef((props, ref) => {
  var {
    onClick,
    isSelected = false,
    isDisabled = false,
    isInactive = false,
    variant
  } = props,
      rest = _objectWithoutProperties(props, _excluded);

  var styles = useStyleConfig('Card', props);

  var handleKeyPress = event => {
    var {
      code
    } = event;
    (code === 'Space' || code === 'Enter') && (onClick === null || onClick === void 0 ? void 0 : onClick(event));
  };

  var isFocusable = !isDisabled && !isInactive;
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "Card",
    "data-selected": isSelected || null,
    "data-inactive": isInactive || null // "Inactive" needs to participate in the aria-disabled for a11y purposes.
    ,
    "aria-disabled": isDisabled || isInactive,
    ref: ref
  }, rest), {}, {
    __css: styles,
    role: onClick ? 'button' : undefined,
    tabIndex: onClick ? isFocusable ? 0 : -1 : undefined,
    onClick: isFocusable ? onClick : undefined,
    onKeyPress: isFocusable ? handleKeyPress : undefined
  }));
});
Card.displayName = 'Card';
//# sourceMappingURL=Card.js.map